import React from 'react';
import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {BettingZoneDrawerMenuItem} from "./betting-zone.drawer-menu.item";
import {BettingZoneDrawerMenuSettings} from "./betting-zone.drawer-menu.settings";

export const BettingZoneDrawerMenuContent = observer(({controller, activeItems, selectedItem, navigate, expandedItemId, setExpandedItemId, setIsMenuVisible}) => {
  const settingsProps = {
    controller,
    selectedItem,
    expandedItemId,
    setExpandedItemId,
    setIsMenuVisible
  }

  return <nav className={classNames(styles.content)}>
    <ul className={classNames(styles.ul)}>
      {
        activeItems?.map((item, index) => <BettingZoneDrawerMenuItem
          controller={controller}
          item={item}
          key={item.id}
          navigate={navigate}
          position={index + 1}
          setIsMenuVisible={setIsMenuVisible}
          expandedItemId={expandedItemId}
          setExpandedItemId={setExpandedItemId}
        />)
      }
      <BettingZoneDrawerMenuSettings {...settingsProps}/>
    </ul>
  </nav>
});